import { StorageService } from "./LocalStorageService";
import { showSpecialDealsModal } from "../utils/modal/ModalManager";

/**
 * Service to handle automatic special deals modal display
 */
export class SpecialDealsService {
  private static hasCheckedThisSession = false;

  /**
   * Check if special deals should be shown and display them if needed
   * This should be called when the app is fully initialized
   */
  static checkAndShowSpecialDeals(): void {
    if (this.hasCheckedThisSession) return;
    this.hasCheckedThisSession = true;

    try {
      const { shouldShowSpecialDeals } = StorageService.initializeSession();
      if (shouldShowSpecialDeals) {
        setTimeout(() => {
          this.showSpecialDealsWithCallback();
        }, 1000);
      }
    } catch (error) {
      console.error("Failed to check and show special deals:", error);
    }
  }

  /**
   * Show special deals modal with proper callback handling
   */
  private static showSpecialDealsWithCallback(): void {
    showSpecialDealsModal(() => {
      // placeholder for post-purchase actions
    });
  }

  /** Reset the session check flag (useful for testing) */
  static resetSessionCheck(): void {
    this.hasCheckedThisSession = false;
  }

  /** Force show (useful for testing) */
  static forceShowSpecialDeals(): void {
    this.showSpecialDealsWithCallback();
  }

  /** Check eligibility without showing */
  static isEligibleForSpecialDeals(): boolean {
    return (
      StorageService.shouldShowSpecialDeals() &&
      !StorageService.hasSpecialDealsBeenShownToday()
    );
  }
}

export default SpecialDealsService;
